<template>
    <validation-provider
        v-slot="{ errors }"
        :name="label || 'This'"
        :rules="rules"
        v-bind="providerProps"
        v-show="innerShouldShow"
        :vid="'validate-' + fieldAssignmentId"
    >
        <div v-if="isMultiple">
            <div class="d-flex flex-column mb-2" v-html="innerLabel"></div>
            <span v-if="directions" v-html="directions" class="mb-2"></span>
            <div
                    v-for="(option, i) in vProps.items"
                    :key="i"
                    :class="innerValue && isSelected(option) ? 'checkbox-new selected' : 'checkbox-new'"
            >
<!--                @change="itemSelected(bindValue && option[bindValue] ? option[bindValue] : option)"-->
                <v-checkbox
                    v-model="innerValue"
                    v-bind="vProps"
                    :value="bindValue ? option[bindValue] : option"
                    :error-messages="errors"
                    :disabled="innerDisabled || (isLimit && innerValue && innerValue.indexOf(bindValue ? option[bindValue] && option[bindValue] : option) === -1)"
                    @click="itemSelected(option)"
                >
                    <span slot="label" v-html="bindLabel && option[bindLabel] ? option[bindLabel] : option"></span>
                </v-checkbox>
            </div>
        </div>

        <div
            v-else-if="mode === 'new'"
            :class="
                multipleInnerValues ? 'checkbox-new selected' : 'checkbox-new'
            "
        >
            <v-checkbox
                v-if="vProps.label.includes('href=')"
                color="primary"
                v-model="innerValue"
                v-bind="vProps"
                :error-messages="errors"
                ><span slot="label" v-html="vProps.label"></span
            ></v-checkbox>
            <v-checkbox
                v-else
                color="primary"
                v-model="innerValue"
                v-bind="vProps"
                :error-messages="errors"
            ></v-checkbox>
        </div>
        <v-checkbox
            v-else
            v-model="innerValue"
            v-bind="vProps"
            :error-messages="errors"
        >
            <template #label>
                <span v-if="innerLabel" v-html="innerLabel"></span>
            </template>
        </v-checkbox>
    </validation-provider>
</template>

<script>
import formMixin from '../formMixin';

export default {
    name: 'TypeCheckbox',
    mixins: [formMixin],
    props: {
        mode: {
            type: String,
            required: false,
            default: 'default'
        },
        bindValue:{
            type:String,
            required: false,
        },
        bindLabel:{
            type:String,
            required: false,
            default: 'label'
        },
        limitSelected:{
            type:Object,
            default:() => {
                return {
                    min:0,
                    max:10000,
                };
            }
        }
    },
    mounted() {
        if( this.innerValue === null || this.innerValue === undefined ) {
            this.innerValue = this.isMultiple ? [] : false;
        }

        this.fieldLoaded(); // signal to the form we are loaded
        this.$nextTick(() => { // let validation observer know it's updated
            this.$emit('change', this.innerValue);
        });
    },
    methods: {
        itemSelected(item) { // this is hacky
            let i = -1;
            if( this.innerValue.length && typeof this.innerValue[0] == 'object' ) {
                i = this.innerValue.findIndex((x) => x.id === item.id || (this.bindLabel && x[this.bindLabel] === item[this.bindLabel])); // TODO:: what if we don't have ids
            } else {
                i = this.innerValue.indexOf(item);
            }

            if( i === -1 )
                this.innerValue.push(item);
            else
                this.innerValue.splice(i, 1);

            this.$emit('change', this.innerValue);
            this.$forceUpdate();
        },
        isSelected(item) {
            return !!this.innerValue.find(x => x.id === item.id || (this.bindValue && x[this.bindValue] === item[this.bindValue]));
        }
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                items: this.value_options || [],
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings
            } : {};
        },
        isMultiple() {
            return this.type_attributes.indexOf('Multiple') > -1;
        },
        multipleInnerValues() {
            // the type of the innvervalue can be different based on the amount of values
            return typeof this.innerValue === 'boolean'
                ? true
                : this.innerValue && this.innerValue.indexOf(this.vProps.label) > -1; // vProps.label may not be fool-proof
        },
        isLimit() {
            return this.innerValue && this.limitSelected && this.innerValue.length >= this.limitSelected.max;
        }
    }
};
</script>

<style lang="scss">
    .checkbox-new {
        label.v-label.theme--light {
            margin-bottom: 0px !important;
        }
    }
</style>
